
import { Options, Vue } from "vue-class-component";
import { ref } from "vue";
import * as echarts from "echarts";
import {
  dispatchGetReportStat,
  dispatchGetVisitStatistics,
  dispatchGetVisitStatTrend,
} from "@/store/project/actions";
import { store } from "@/store";
import { getLocalProject } from "@/utils";
import {
  readReportStat,
  readVisitStatistics,
  readVisitStatTrend,
} from "@/store/project/getters";
@Options({
  components: {},
})
export default class OperationalData extends Vue {
  public localProject = Number(getLocalProject());
  public loading = false;
  public record = 10; //记录条数
  public statistics = 10; //统计条数
  public record_input = ""; //记录搜索
  public statistics_input = ""; //统计搜索
  public currentPage1 = 1;
  public currentPage2 = 1;
  public start_date = this.getDay(-6);
  public end_date = this.getDay(0);

  // 时间选择器
  public Timevalue = ref("");
  public defaultTime = ref([
    new Date(2000, 1, 1, 0, 0, 0),
    new Date(2000, 2, 1, 23, 59, 59),
  ]); // '00:00:00', '23:59:59'

  //图表
  public get TrendChart() {
    let trend_chart: any = document.getElementById("trend_chart");
    echarts.dispose(trend_chart);
    let PerformanceLineChart = echarts.init(trend_chart);
    let option;
    option = {
      title: {
        text: "平台访问趋势",
        left: "center",
        textStyle: {
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        x: "center",
        y: "bottom",
        data: ["平台页面浏览量", "平台用户访问量"],
      },
      grid: {
        left: "3%",
        top: "20%",
        bottom: "15%",
        right: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
          magicType: { show: true, type: ["line", "bar"] },
        },
      },
      xAxis: {
        type: "category",
        // boundaryGap: false,
        data: this.getVisitStatTrend.date_list,
      },

      yAxis: [
        {
          name: "访问次数",
          type: "value",
          min: 0,
          max: Math.max(...this.getVisitStatTrend.platform_page_views),
          axisLabel: {
            formatter: function (v: any) {
              return parseInt(v); //表示整数。其他数值类型以此类推
            },
          },
        },
        {
          name: "用户访问量",
          type: "value",
          min: 0,
          max: Math.max(...this.getVisitStatTrend.platform_user_visits),
          axisLabel: {
            formatter: function (v: any) {
              return parseInt(v); //表示整数。其他数值类型以此类推
            },
          },
        },
      ],
      series: [
        {
          name: "平台页面浏览量",
          type: "bar",
          data: this.getVisitStatTrend.platform_page_views,
          yAxisIndex: 0,
        },
        {
          name: "平台用户访问量",
          type: "bar",
          data: this.getVisitStatTrend.platform_user_visits,
          yAxisIndex: 1,
        },
      ],
    };

    PerformanceLineChart.setOption(option);
    return PerformanceLineChart;
  }

  public async mounted() {
    this.loading = true;
    await dispatchGetReportStat(store, {
      project: this.localProject,
      search: this.statistics_input,
      size: this.statistics,
      page: this.currentPage2,
    });
    await dispatchGetVisitStatistics(store, {
      project: this.localProject,
      search: this.record_input,
      size: this.record,
      page: this.currentPage1,
    });
    await dispatchGetVisitStatTrend(store, {
      start_date: this.start_date,
      end_date: this.end_date,
    });
    await this.TrendChart;
    this.loading = false;
  }

  // 获得统计数据
  public get getReportStat() {
    return readReportStat(store);
  }
  // 获得记录数据
  public get getVisitStatistics() {
    return readVisitStatistics(store);
  }

  // 获得趋势
  public get getVisitStatTrend() {
    return readVisitStatTrend(store);
  }

  // 一页显示
  public async showList(show: any) {
    this.loading = true;
    if (show === "statistics_input") {
      await dispatchGetReportStat(store, {
        project: this.localProject,
        search: this.statistics_input,
        size: this.statistics,
        page: this.currentPage2,
      });
    } else {
      await dispatchGetVisitStatistics(store, {
        project: this.localProject,
        search: this.record_input,
        size: this.record,
        page: this.currentPage1,
      });
    }
    this.loading = false;
  }
  // 分页
  public async handleCurrentChange(page: any) {
    this.loading = true;
    if (page === "statistics_input") {
      await dispatchGetReportStat(store, {
        project: this.localProject,
        search: this.statistics_input,
        size: this.statistics,
        page: this.currentPage2,
      });
    } else {
      await dispatchGetVisitStatistics(store, {
        project: this.localProject,
        search: this.record_input,
        size: this.record,
        page: this.currentPage1,
      });
    }
    this.loading = false;
  }
  // 序号
  public indexMethod(index: any, val: any) {
    if (val === "statistics_input") {
      return index + 1 + (this.currentPage2 - 1) * this.record;
    } else {
      return index + 1 + (this.currentPage1 - 1) * this.statistics;
    }
  }

  // 搜索
  public async recordSearch(search: any) {
    this.loading = true;
    if (search === "statistics_input") {
      await dispatchGetReportStat(store, {
        project: this.localProject,
        search: this.statistics_input,
        size: this.statistics,
        page: this.currentPage2,
      });
    } else {
      await dispatchGetVisitStatistics(store, {
        project: this.localProject,
        search: this.record_input,
        size: this.record,
        page: this.currentPage1,
      });
    }
    this.loading = false;
  }

  // 清空
  public async clearSearch(search: any) {
    this.loading = true;
    this.statistics = 10;
    this.record = 10;
    if (search === "statistics_input") {
      this.statistics_input = "";
      this.currentPage2 = 1;
      await dispatchGetReportStat(store, {
        project: this.localProject,
        search: this.statistics_input,
        size: 10,
        page: this.currentPage2,
      });
    } else {
      this.record_input = "";
      this.currentPage1 = 1;
      await dispatchGetVisitStatistics(store, {
        project: this.localProject,
        search: this.record_input,
        size: 10,
        page: this.currentPage1,
      });
    }
    this.loading = false;
  }

  // 获取时间
  public async getTime() {
    this.loading = true;
    const start_date = Object.values(this.Timevalue)[0];
    const end_date = Object.values(this.Timevalue)[1];
    await dispatchGetVisitStatTrend(store, {
      start_date: start_date,
      end_date: end_date,
    });
    await this.TrendChart;
    this.loading = false;
  }

  // 最近一周的时间
  public async getTime2() {
    this.loading = true;
    await dispatchGetVisitStatTrend(store, {
      start_date: this.start_date,
      end_date: this.end_date,
    });
    await this.TrendChart;
    this.loading = false;
  }

  // 获取日期
  public getDay(day: any) {
    var today = new Date();
    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  }
  public doHandleMonth(month: any) {
    var m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  }
}
